import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import BOOKLISTTheme from '@legacy/helpers/material-ui.theme.js.es6';
import constants from '@legacy/helpers/constants.js.es6';
import typeUtils from '@legacy/helpers/utils/typeUtils.js.es6';
import { colors } from '@legacy/helpers/vst-colors.js.es6';
import { default as Icon } from '@legacy/components/icons/InfoIcon.es6.jsx';

const _theme = getMuiTheme(BOOKLISTTheme);
const { icon } = constants;

const LoadingIndicator = ({ color, defaultColor = colors.SANGRIA, loading }) => {
    const fillColor = typeUtils.isString(color) ? color : defaultColor;

    return (
        <MuiThemeProvider muiTheme={ _theme }>
            <div className={`bl-loading-indicator__container${loading !== true ? ' hidden' : ''}`}>
                <div className="bl-loading-indicator">
                    <div className="bl-loading-indicator__spinner-backdrop">
                        <Icon
                            use={ icon.LOADER }
                            fill={ fillColor }
                        />
                    </div>
                </div>
            </div>
        </MuiThemeProvider>
    );
};

export default LoadingIndicator;